export const PlayIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="33"
			height="33"
			viewBox="0 0 33 33"
			fill="none"
		>
			<path
				d="M16.5 30.2461C24.0939 30.2461 30.25 24.09 30.25 16.4961C30.25 8.90218 24.0939 2.74609 16.5 2.74609C8.90608 2.74609 2.75 8.90218 2.75 16.4961C2.75 24.09 8.90608 30.2461 16.5 30.2461Z"
				fill="#196DFE"
			/>
			<path
				d="M21.1942 15.0386C22.2681 15.6738 22.2681 17.3156 21.1942 17.9508L14.7043 21.7829C13.6593 22.3989 12.375 21.596 12.375 20.3254V12.6639C12.375 11.3934 13.6593 10.5918 14.7043 11.2078L21.1942 15.0386Z"
				fill="white"
			/>
		</svg>
	);
};
